import { MenuQuery } from '@/fo/api/magento';

import { mapMenuItem } from '../helpers/mapMenuItem';
import { MenuIdentifier } from '../types';

export const utilMapMenuData = (menu?: MenuQuery['snowdogMenus']) => {
  if (!menu) {
    return {
      catalog: [],
      brands: [],
      diagnostic: [],
      aboutSkin: [],
      mobile: [],
      toBuyers: [],
      checkoutFooter: [],
      brandsSitemap: []
    };
  }

  return {
    catalog: mapMenuItem(menu, MenuIdentifier.Catalog),
    brands: mapMenuItem(menu, MenuIdentifier.Brands),
    diagnostic: mapMenuItem(menu, MenuIdentifier.Diagnostic),
    aboutSkin: mapMenuItem(menu, MenuIdentifier.AboutSkin),
    mobile: mapMenuItem(menu, MenuIdentifier.Mobile),
    toBuyers: mapMenuItem(menu, MenuIdentifier.ToBuyers),
    checkoutFooter: mapMenuItem(menu, MenuIdentifier.CheckoutFooter),
    brandsSitemap: mapMenuItem(menu, MenuIdentifier.BrandsSitemap)
  };
};
